/**
 * Data Source abstraction for managing operations with data reading / fetching / updating .etc
 */
export abstract class DataSource<S> {

    /**
     * Get list of items.
     */
    public abstract getList(): Promise<any>;
}